import React from 'react';
import { FreebetsTable } from './FreebetsTable';

export const FreebetsList: React.FC = () => {
  return <FreebetsTable />;
};
